module.exports = __webpack_public_path__ + "static/ilustracao-curva-abc-7d341897aa4b479d48cf2b62e0a13d1a.svg";